import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function sortByAsObservable<T>(
  array: Observable<T[] | undefined>,
  sortProperty: string
) {
  return array?.pipe(map((item) => sortBy(item, sortProperty)));
}

export function sortBy<T>(array: T[] | undefined, sortProperty: string, isDesc: boolean = false) {
  return array?.sort((a: any, b: any) => {
    const valueA = getValueFromObject(a, sortProperty);
    const valueB = getValueFromObject(b, sortProperty);    
    let comparison = valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
    return isDesc ? -comparison : comparison;
  });
}

export function sortByNicknameOrTitle<T>(array: T[] | undefined, isDesc: boolean = false): T[] | undefined {
  return array?.sort((a: any, b: any) => {
    const valueA = a.nickname || a.title || '';
    const valueB = b.nickname || b.title || '';
    let comparison = valueA.localeCompare(valueB);
    return isDesc ? -comparison : comparison;
  });
}

export function sortByDate<T>(array: T[] | undefined, sortProperty: string, isDesc: boolean = true) {
  return array?.sort((a: any, b: any) => {
    const valueA = new Date(getValueFromObject(a, sortProperty)).getTime();
    const valueB = new Date(getValueFromObject(b, sortProperty)).getTime();
    return isDesc ? valueB - valueA : valueA - valueB;
  });
}

/**
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function getValueFromObject(object: any, path: string) {
    return path
    .split('.')
    .reduce((o, p) => (o ? (o[p] !== undefined ? o[p] : null) : null), object);
}
